import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getAuth } from 'firebase/auth';
import {environment} from "../../environments/environment";

export interface FlowerStockBouquetEntry {
  index: number;
  items: Record<string, number>;
}

export interface FlowerStockCutFlowerEntry {
  product: string;
  opening: number;
  scrap: number;
  sold: number;
  closing?: number;
}

export interface FlowerStockResponse {
  date: string;
  bouquets?: FlowerStockBouquetEntry[];
  cutFlowers?: FlowerStockCutFlowerEntry[];
}

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private baseUrl = environment.apiUrl + '/api';
  constructor(private http: HttpClient) {}

  fetchSubscriberByQr(qrCode: string): Observable<any> {
    const auth = getAuth();

    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        const params = new HttpParams().set('qr', qrCode);

        return this.http.get<any>(`${this.baseUrl}/admin/subscriber`, {
          headers,
          params,
        });
      })
    );
  }

  drawGift(qrCode: string, amount: number, coupon: string): Observable<any> {
    const auth = getAuth();

    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        const body = { qrCode, amount, coupon };

        return this.http.post<any>(`${this.baseUrl}/admin/subscriber/draw`, body, { headers });
      })
    );
  }

  getFlowerStock(date: string): Observable<FlowerStockResponse> {
    const auth = getAuth();

    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.http.get<FlowerStockResponse>(`${this.baseUrl}/admin/flower-stock/${date}`, { headers });
      })
    );
  }

  saveFlowerStockBouquets(date: string, payload: { date: string; bouquets: FlowerStockBouquetEntry[] }): Observable<FlowerStockResponse> {
    const auth = getAuth();

    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.http.put<FlowerStockResponse>(`${this.baseUrl}/admin/flower-stock/${date}/bouquets`, payload, {
          headers,
        });
      })
    );
  }

  saveFlowerStockCutFlowers(date: string, payload: { date: string; items: FlowerStockCutFlowerEntry[] }): Observable<FlowerStockResponse> {
    const auth = getAuth();

    return from(auth.currentUser?.getIdToken(true) ?? Promise.reject('Nincs bejelentkezett felhasználó')).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.http.put<FlowerStockResponse>(`${this.baseUrl}/admin/flower-stock/${date}/cut-flowers`, payload, {
          headers,
        });
      })
    );
  }

}
